import api from './api';

const BASE = '/admin/support';

export const supportAPI = {
  getConversations: async (params = {}) => {
    const response = await api.get(`${BASE}/conversations/`, { params });
    return response.data;
  },

  getConversationDetail: async (id) => {
    const response = await api.get(`${BASE}/conversations/detail/`, { params: { id } });
    return response.data;
  },

  closeConversation: async (id) => {
    const response = await api.patch(`${BASE}/conversations/close/`, { id });
    return response.data;
  },

  sendMessage: async (payload) => {
    const response = await api.post(`${BASE}/messages/send/`, payload);
    return response.data;
  },

  getMessages: async (conversation_id, page = 1, page_size = 30) => {
    const response = await api.get(`${BASE}/messages/`, {
      params: { conversation_id, page, page_size },
    });
    return response.data;
  },

  getStats: async () => {
    const response = await api.get(`${BASE}/stats/`);
    return response.data;
  },
};
